// @ts-nocheck
import React, { Component } from 'react';
import { inject, observer } from "../../../stores/mobx-compat";

import Modal, { ModalActions } from '../../ui/Modal';
import Button from '../../ui/Button';
import FormGroup from '../../ui/FormGroup';
import Input from '../../ui/Input';
import { LockIcon, CheckCircleIcon } from '../../ui/icons';

class ConfirmationModal extends Component {
  state = { phone: '', email: '' };

  validatePhone = () => {
    if (this.state.phone.trim().length !== 10 || +this.state.phone.trim() <= 0) {
      this.props.store.failure('Phone number must be 10 digits.');
      return false;
    }
    if (this.props.phoneNumber !== this.state.phone) {
      this.props.store.failure('Phone numbers do not match.');
      return false;
    }
    return true;
  }

  validateEmail = () => {
    if (this.props.email !== this.state.email) {
      this.props.store.failure('Email addresses do not match.');
      return false;
    }
    return true;
  }

  fromDisabled = () => {
    const { twoFaType } = this.props;
    if (twoFaType === 'text' || twoFaType === '') {
      return (
        <Modal
          open={this.props.open}
          onClose={this.props.onClose}
          title="Confirm phone number"
          icon={LockIcon}
          closeOnScrim={false}
          actions={(
            <ModalActions
              onCancel={this.props.onClose}
              onConfirm={() => { if (this.validatePhone()) this.props.confirm(); }}
              confirmLabel="Confirm"
              confirmLoading={this.props.store.auth.loading}
            />
          )}
        >
          <FormGroup label="Phone number">
            <Input
              prefix="+1"
              placeholder="1234567890"
              value={this.state.phone}
              onChange={(e) => this.setState({ phone: e.target.value })}
            />
          </FormGroup>
        </Modal>
      );
    }
    return (
      <Modal
        open={this.props.open}
        onClose={this.props.onClose}
        title="Confirm email address"
        icon={LockIcon}
        closeOnScrim={false}
        actions={(
          <ModalActions
            onCancel={this.props.onClose}
            onConfirm={() => { if (this.validateEmail()) this.props.confirm(); }}
            confirmLabel="Confirm"
            confirmLoading={this.props.store.auth.loading}
          />
        )}
      >
        <FormGroup label="Email address">
          <Input
            placeholder="name@email.com"
            value={this.state.email}
            onChange={(e) => this.setState({ email: e.target.value })}
          />
        </FormGroup>
      </Modal>
    );
  }

  fromEnabled = () => (
    <Modal
      open={this.props.open}
      onClose={this.props.onClose}
      title="Re-enter your latest 2FA code"
      icon={LockIcon}
      closeOnScrim={false}
      actions={(
        <>
          <Button onClick={this.props.onClose}>Cancel</Button>
          <Button
            onClick={this.props.store.auth.sendCode}
            loading={this.props.store.auth.loading}
          >
            Send again
          </Button>
          <Button
            variant="primary"
            onClick={this.props.confirm}
            loading={this.props.store.auth.loading}
          >
            Confirm
          </Button>
        </>
      )}
    >
      <FormGroup label="Code">
        <Input
          name="twoFaCode"
          value={this.props.twoFaCode}
          onChange={(e) => this.props.formInput(null, { name: 'twoFaCode', value: e.target.value })}
        />
      </FormGroup>
    </Modal>
  );

  success = () => (
    <Modal
      open={this.props.open}
      onClose={this.props.onClose}
      title="Success"
      icon={CheckCircleIcon}
      actions={(
        <Button variant="primary" onClick={this.props.onClose}>Done</Button>
      )}
    >
      <p className="m-0 text-[13px] text-mov-ink-soft">Your 2FA settings have been updated.</p>
    </Modal>
  );

  render() {
    if (!this.props.open) return null;
    if (this.props.success) return this.success();
    return this.props.original2FaType === '' ? this.fromDisabled() : this.fromEnabled();
  }
}

export default inject('store')(observer(ConfirmationModal));
